import { ProxyMediaArgs } from '@sparemin/api-sdk';
import { createApiAction } from '../utils';
import { ACTION_KEY, ExternalMediaExistsArgs, ServiceMethod } from './types';

function apiCallAction<M extends ServiceMethod, A = undefined>(
  method: M,
  args?: A,
) {
  return createApiAction(ACTION_KEY, method, args);
}

export function getExternalMedia(args: ProxyMediaArgs) {
  return apiCallAction(ServiceMethod.PROXY_MEDIA, args);
}

export function externalMediaExists(url: string) {
  return apiCallAction(ServiceMethod.EXTERNAL_MEDIA_EXISTS, [
    url,
  ] as ExternalMediaExistsArgs);
}
